import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import Collapse from 'antd/lib/collapse';
import { DisposeLoanCollapseList } from '.';

const CollapsePanel = Collapse.Panel;

const DisposeLoanCollapse = ({ loan, token, t, items, accountRole }) => (
  <Collapse>
    <CollapsePanel header={t('Odpredaj pôžičky')}>
      <DisposeLoanCollapseList loan={loan} token={token} accountRole={accountRole} items={items} />
    </CollapsePanel>
  </Collapse>
);

DisposeLoanCollapse.propTypes = {
  loan: PropTypes.object.isRequired,
  token: PropTypes.string.isRequired,
  accountRole: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  t: PropTypes.func.isRequired,
};

export default translate()(DisposeLoanCollapse);



// WEBPACK FOOTER //
// ./src/common/components/data-display/DisposeLoanCollapse.js